import { render } from "./B2bChangePassword.vue?vue&type=template&id=094c1f9b&scoped=true&lang=pug"
import script from "./B2bChangePassword.vue?vue&type=script&lang=js"
export * from "./B2bChangePassword.vue?vue&type=script&lang=js"

import "./B2bChangePassword.vue?vue&type=style&index=0&id=094c1f9b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094c1f9b"]])

export default __exports__